<template>
  <Card :bordered="false" class="border-radius-0">
    <CardBorder :title="$t('lab.countryStandardGroupMapper.productType')">
      <Form :ref="(e) => (refs.form = e)" layout="horizontal">
        <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields"></TemplateBuilder>
      </Form>
    </CardBorder>
    <CTable
            v-if="state.columns?.length && data.labType && data.productType && data.labCountryStandardGroup"
            :isLoading="isLoading"
            v-model:columns="state.columns"
            v-model:page="state.page"
            :options="state.tableOptions"
            :manages="state.manages"
            :manageExtras="state.manageExtras"
            :rowActions="state.rowActions"
            @search="search => onSearch({...search, data})"
    ></CTable>
  </Card>
</template>

<script>
    import { defineAsyncComponent, defineComponent, reactive } from "vue";
    import {
        initState,
        isLoading,
        onSearch,
        state
    } from "./country-standard-group-topic.logic";
    import { has } from "../../../../../utils/menu-context";
    import { Card, Form } from "ant-design-vue";
    import { state as stateApp } from "../../../../../app.logic";

    export default defineComponent({
        name: "list-product-grouping",
        components: {
            Card,
            Form,
            TemplateBuilder: defineAsyncComponent(() => import("../../../../../components/input/template-builder/TemplateBuilder")),
            CTable: defineAsyncComponent(() => import("../../../../../components/table/CTable")),
            CardBorder: defineAsyncComponent(() => import("../../../../../components/card/CardBorder"))
        },
        props: {
            menuContext: { default: () => stateApp.menuContext },
            viewOnly: { default: false },
        },
        setup(props) {
            const data = reactive({ searchLabType: null });
            const refs = reactive({ form: null });

            initState({ props, data, refs });
            return { isLoading, state, onSearch, data, refs, props, has };
        }
    });
</script>
